import * as z from "zod";
import { UserRole } from "model/user/userRole";
import { Language } from "model/user/language";
import { FileSchema } from "model/user/file";

export const CapabilitySchema = z.object({
    capability: z.string(),
    authorized: z.boolean(),
});
export type CapabilityModel = z.infer<typeof CapabilitySchema>;

export const CapabilitiesSchema = z.array(CapabilitySchema);
export type CapabilitiesModel = z.infer<typeof CapabilitiesSchema>;

export const ProfileSchema = z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    displayName: z.string(),
    gender: z.string().nullable(),
    avatar: FileSchema.nullable(),
    dateOfBirth: z.string().nullable(),
    countryId: z.number().nullable(),
    emailAddress: z.string(),
    emailAddressVerified: z.boolean(),
    phoneNumber: z.string().nullable(),
    phoneNumberVerified: z.boolean(),
    role: z.nativeEnum(UserRole),
    organizationId: z.number().nullable(),
    languageId: z.nativeEnum(Language),
    timeZone: z.string(),
    capabilities: CapabilitiesSchema,
});

export type Profile = z.infer<typeof ProfileSchema>;
